import * as React from "react";

/**
 * Standard underline tab button, used inside StickyRouteHeader's `tabs` prop.
 * Shared across integration pages AND any other tab bar (e.g. Chatbot Training) —
 * always use this instead of a page-local copy so padding/color stay in sync everywhere.
 */
export function IntegrationTab({
  active,
  onClick,
  children,
  activeColorClass = "border-(--ds-primary) text-(--ds-primary)"
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
  /** Override the active border/text color classes (defaults to the theme primary token). */
  activeColorClass?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap inline-flex items-center gap-1.5 ${
        active
          ? activeColorClass
          : "border-transparent text-zinc-500 hover:text-zinc-700 hover:border-zinc-300"
      }`}
    >
      {children}
    </button>
  );
}

export default IntegrationTab;
